module.exports = __webpack_public_path__ + "static/media/product-3-back.19216f8d.jpg";